import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { first } from 'lodash';
import { filterEmptyValues } from 'libs/utils/object';

const getSelectedDynamicFiltersParams = selectedDynamicFilters => {
  const dynamicParams = {};
  selectedDynamicFilters.forEach(_ref => {
    let {
      type,
      ids
    } = _ref;
    dynamicParams["".concat(type, "_ids")] = ids;
  });
  return dynamicParams;
};

export const filtersToApiParams = (filters, selectedDynamicFilters) => {
  const params = {
    search_text: filters.query || undefined,
    brand_ids: filters.brandIds,
    color_ids: filters.colorIds,
    size_ids: filters.sizeIds,
    material_ids: filters.materialIds,
    video_game_rating_ids: filters.videoGameRatingIds,
    status_ids: filters.statusIds,
    catalog_id: first(filters.catalogIds),
    price_from: filters.priceFrom || undefined,
    price_to: filters.priceTo || undefined,
    currency: filters.currency || undefined
  };
  return filterEmptyValues(_objectSpread(_objectSpread({}, params), getSelectedDynamicFiltersParams(selectedDynamicFilters)));
};